const getCSSVariableAsNumber = (args: { cssVariable: string }) => {
  const root = document.querySelector(':root') as HTMLElement;

  let value = parseInt(root.style.getPropertyValue(args.cssVariable), 10);
  if (isNaN(value)) {
    return 0;
  } else {
    return value;
  }
};

export function incrementCSSVariableCounter(args: { cssVariable: string }) {
  const currentValue = getCSSVariableAsNumber({
    cssVariable: args.cssVariable,
  });

  document.documentElement.style.setProperty(
    args.cssVariable,
    (currentValue + 1).toString()
  );
}

export function decrementCSSVariableCounter(args: { cssVariable: string }) {
  const currentValue = getCSSVariableAsNumber({
    cssVariable: args.cssVariable,
  });

  document.documentElement.style.setProperty(
    args.cssVariable,
    Math.max(currentValue - 1, 0).toString()
  );
}
